/** @jsx jsx */
/* eslint-disable no-use-before-define,no-empty-pattern */
import { jsx } from '@emotion/core'
import React from 'react'
import { listCss } from '../style'
import { useCalculator } from '../use-calculator'
import { isEmpty, fmt, COUPON_FREQUENCY_LABELS, COUPON_DAY_COUNT_LABELS, YES_NO, SectionHeader, SectionBody } from '../../twd'

export const Header = () => {

    const { bondInfo } = useCalculator()
    const [showSection, setShowSection] = React.useState(false)

    if (isEmpty(bondInfo)) return null

    const issue = bondInfo.issue || {}
    const bestoffer = bondInfo.bestoffer|| {}


    return <React.Fragment>
        <div className="row calculator-bond-details-headers">
        <div className={"col-md-12"}>
            <SectionHeader
                title="Bond details"
                cls="subhead"
                arrowSize='large'
                show={showSection}
                setShow={setShowSection}
            />
        </div>
        </div>

        <SectionBody show={showSection}>
        <div className="row vertical-offset-base calculator-bond-details-headers">
        <dl css={listCss}>
            <div className="col-md-4 col-xs-12">
            <dt>Type</dt>
            <dd>{(() => {
                let invType = issue.spInd==='Y' ? 'L' : issue.type
                return INV_TYPE_LABELS[invType] || fmt.empty()
            })()}</dd>
            <dt>CUSIP</dt>
            <dd>{issue.cusip}</dd>
            <dt>Maturity date</dt>
            <dd>{fmt.mdy(issue.maturity)}</dd>
            <dt>Settlement date</dt>
            <dd>{fmt.mdy(bondInfo.settlement) || fmt.empty()}</dd>
            <dt>Frequency</dt>
            <dd>{COUPON_FREQUENCY_LABELS[issue.frequencyCode] || fmt.empty()}</dd>
            </div>

            <div className="col-md-4 col-xs-12">
            <dt>Day Count</dt>
            <dd>{COUPON_DAY_COUNT_LABELS[issue.currDaycount] || fmt.empty()}</dd>
            <dt>Redemption value</dt>
            <dd>{fmt.price3(issue.redemptionPrice)}</dd>
            <dt>Issue date</dt>
            <dd>{fmt.mdy(issue.issueDt)}</dd>
            <dt>First coupon date</dt>
            <dd>{fmt.mdy(issue.firstCoupon)}</dd>
            <dt>Last coupon date</dt>
            <dd>{fmt.mdy(issue.lastCoupon)}</dd>
            </div>

            <div className="col-md-4 col-xs-12">
            <dt>Coupon</dt>
            <dd>{fmt.ytw3(issue.coupon)}</dd>
            <dt>Federally taxable</dt>
            <dd>{YES_NO[issue.taxable] || fmt.empty()}</dd>
            <dt>State taxable</dt>
            <dd>{YES_NO[issue.stateTaxExempt==='No' ? 'N' : 'Y'] || fmt.empty()}</dd>
            <dt>Call date</dt>
            <dd>{fmt.mdy(bestoffer.ytcRdate)}</dd>
            <dt>Call price</dt>
            <dd>{fmt.price3(bestoffer.ytcRprice)}</dd>
            </div>
        </dl>
        </div>
        </SectionBody>
    </React.Fragment>

}


export const INV_TYPE_LABELS = {
    'A': 'Agency',
    'R': 'Pass-Through',
    'K': 'Asset-Backed',
    'S': 'CD',
    'O': 'CMO',
    'C': 'Corporate',
    'M': 'Municipal',
    'P': 'Preferred',
    'L': 'Structured',
    'T': 'Treasury',
}
